import React, { useEffect, useState } from "react";
import "./MockCard.css";
import { BASE_URL, /* objectivequizApi, */ subjectivequizApi /*, fullmocktestApi */ } from "../../../api/api";
import api from "../../../utils/api";
import { useNavigate } from "react-router-dom";

const MockCard = () => {
    const [mockData, setMockData] = useState([]);
    const [timeLeft, setTimeLeft] = useState({});
    // const [filter, setFilter] = useState("all"); //  filter state (commented)
    const navigate = useNavigate();

    // Normalize API response
    const normalizeData = (res) => {
        if (Array.isArray(res.data)) return res.data;
        if (Array.isArray(res.data?.data)) return res.data.data;
        return [];
    };

    // Fetch Data (Only Subjective)
    const fetchData = async () => {
        try {
            // ✅ Only fetch subjective mock
            const res = await api.get(`${subjectivequizApi}`);
            setMockData(normalizeData(res).map(item => ({ ...item, type: "subjective" })));

            // ❌ Commented out Objective + Full Mock fetching
            /*
            if (type === "all") {
                const [obj, subj, full] = await Promise.all([
                    api.get(`${objectivequizApi}`),
                    api.get(`${subjectivequizApi}`),
                    api.get(`${fullmocktestApi}`)
                ]);

                const allData = [
                    ...normalizeData(obj).map(item => ({ ...item, type: "objective" })),
                    ...normalizeData(subj).map(item => ({ ...item, type: "subjective" })),
                    ...normalizeData(full).map(item => ({ ...item, type: "fullmock" })),
                ];
                setMockData(allData);
            } else if (type === "objective") {
                const res = await api.get(`${objectivequizApi}`);
                setMockData(normalizeData(res).map(item => ({ ...item, type: "objective" })));
            } else if (type === "fullmock") {
                const res = await api.get(`${fullmocktestApi}`);
                setMockData(normalizeData(res).map(item => ({ ...item, type: "fullmock" })));
            }
            */
        } catch (err) {
            console.error("Error fetching mock tests:", err);
            setMockData([]);
        }
    };

    useEffect(() => {
        fetchData(); // ✅ Always fetch subjective mocks
    }, []); // removed filter dependency

    // Timer Effect
    useEffect(() => {
        if (mockData.length > 0) {
            const interval = setInterval(() => {
                const updatedTimes = {};
                mockData.forEach((item) => {
                    const endTime = new Date(item.test_end_date).getTime();
                    const now = new Date().getTime();
                    const diff = endTime - now;

                    if (diff <= 0) {
                        updatedTimes[item.id] = "Expired";
                        return;
                    }

                    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                    const pad = (num) => String(num).padStart(2, "0");

                    if (days >= 1) {
                        updatedTimes[item.id] = `${days}d:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                    } else {
                        updatedTimes[item.id] = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                    }
                });
                setTimeLeft(updatedTimes);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [mockData]);

    return (
        <div className="mock-card-wrapper">
            {/* ❌ Filter Buttons commented out
            <div className="mock-card-filter-buttons">
                <button
                    className={`mock-card-filter-btn ${filter === "all" ? "active" : ""}`}
                    onClick={() => setFilter("all")}
                >
                    All
                </button>
                <button
                    className={`mock-card-filter-btn ${filter === "objective" ? "active" : ""}`}
                    onClick={() => setFilter("objective")}
                >
                    Objective
                </button>
                <button
                    className={`mock-card-filter-btn ${filter === "subjective" ? "active" : ""}`}
                    onClick={() => setFilter("subjective")}
                >
                    Subjective
                </button>
                <button
                    className={`mock-card-filter-btn ${filter === "fullmock" ? "active" : ""}`}
                    onClick={() => setFilter("fullmock")}
                >
                    Full Mock Length
                </button>
            </div>
            */}

            <div className="mock-main-card">
                {(!Array.isArray(mockData) || mockData.length === 0) && (
                    <div className="w-full flex flex-col items-center justify-center py-16 px-4">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 rounded-full mb-6">
                            <svg
                                className="w-10 h-10 text-yellow-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                                />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold text-neutral-900 mb-2">
                            No Mock Tests Available
                        </h3>
                        <p className="text-sm font-medium text-gray-500 text-center max-w-sm">
                            Check back later for new tests. We'll notify you when new mock tests are added.
                        </p>
                    </div>
                )}
                {Array.isArray(mockData) && mockData.map((item, index) => {
                    const localKey = `attempted_test_${item.id}`;
                    const attemptCount = parseInt(localStorage.getItem(localKey)) || 0;
                    const attemptLeft = item.max_attempt - attemptCount;

                    return (
                        <div className="mock-card" key={index}>
                            <div className="mock-card-profile">
                                <img src="/assets/subjective-test.jpg" alt="Test Profile" />
                            </div>
                            <div className="mock-card-content">
                                <h3 className="mock-card-title">{item.test_name}</h3>
                                <p className="mock-card-instructor">{item.subject_name}</p>
                                <p className="mock-card-desc">{item.test_description}</p>
                                <p className="mock-card-attempt">
                                    {attemptLeft} / {item.max_attempt} attempt left
                                </p>

                                {/* <button
                                    className="reset-button"
                                    onClick={() => {
                                        localStorage.removeItem(localKey);
                                        window.location.reload();
                                    }}
                                >
                                    🔁 Reset Attempt
                                </button> */}

                                <div className="button-group-row">
                                    {attemptLeft > 0 && (
                                        <button
                                            className="primary-button w-100"
                                            onClick={() => {
                                                const localKey = `attempt_${item.id}`;
                                                const attemptCount = parseInt(localStorage.getItem(localKey) || "0", 10);
                                                const newCount = attemptCount + 1;
                                                localStorage.setItem(localKey, newCount.toString());

                                                // Only subjective test navigation
                                                navigate(`/subjective-test-instruction/${item.id}`);
                                            }}
                                        >
                                            Start
                                        </button>
                                    )}

                                    {attemptCount > 0 && (
                                        <button
                                            className="success-button w-100"
                                            onClick={() => navigate(`/view-response/${item.type}/${item.id}`)}
                                        >
                                            View Response
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MockCard;
